// Main Navigation JavaScript
// Adapted from nav-template.html for Shopify Axiom theme

// State management
let isMobileMenuOpen = false;
let expandedMobileItems = new Set();
let dropdownTimeouts = new Map(); // For managing hover delays

// Initialize dropdown positioning for desktop
function calculateDropdownPosition(dropdown) {
    const header = document.getElementById('header');
    const headerRect = header.getBoundingClientRect();
    const viewportWidth = window.innerWidth;

    // For regular dropdowns, position center below nav item
    if (dropdown.dataset.type === 'regular') {
        dropdown.style.position = 'absolute';
        dropdown.style.top = 'calc(100% + 12px)';
        dropdown.style.left = '50%';
        dropdown.style.transform = 'translateX(-50%)';
        dropdown.style.zIndex = '60';
        dropdown.style.minWidth = 'auto';
    }
    // For full dropdowns, center in viewport
    else if (dropdown.dataset.type === 'full') {
        const dropdownWidth = Math.min(viewportWidth * 0.95, 1536);
        const leftPosition = (viewportWidth - dropdownWidth) / 2;

        dropdown.style.position = 'fixed';
        dropdown.style.left = `${leftPosition}px`;
        // dropdown.style.top = `${topPosition}px`;
        dropdown.style.top = 'calc(100%)';
        dropdown.style.width = `${dropdownWidth}px`;
        dropdown.style.zIndex = '60';
        dropdown.style.visibility = 'visible';
    }
}

// Handle window resize for dropdown positioning
function handleResize() {
    // Reposition all visible dropdowns immediately
    const visibleDropdowns = document.querySelectorAll('.dropdown-menu.show');
    visibleDropdowns.forEach((dropdown) => {
        calculateDropdownPosition(dropdown);
    });
}

// Initialize desktop navigation dropdowns with hover
function initDesktopNav() {
    const navItems = document.querySelectorAll('#desktop-nav .nav-item');

    navItems.forEach((navItem) => {
        const dropdown = navItem.querySelector('.dropdown-menu');
        if (!dropdown) return;

        // Show dropdown on hover
        navItem.addEventListener('mouseenter', () => {
            // Clear any existing timeout for this dropdown
            if (dropdownTimeouts.has(navItem)) {
                clearTimeout(dropdownTimeouts.get(navItem));
                dropdownTimeouts.delete(navItem);
            }

            // Close all other dropdowns immediately
            document
                .querySelectorAll('#desktop-nav .nav-item')
                .forEach((otherNavItem) => {
                    const otherDropdown =
                        otherNavItem.querySelector('.dropdown-menu');
                    if (otherDropdown && otherDropdown !== dropdown) {
                        otherDropdown.classList.remove('show');
                        // Clear timeout for other dropdowns
                        if (dropdownTimeouts.has(otherNavItem)) {
                            clearTimeout(dropdownTimeouts.get(otherNavItem));
                            dropdownTimeouts.delete(otherNavItem);
                        }
                    }
                });

            // For full dropdowns, position BEFORE showing to prevent visual jump
            if (dropdown.dataset.type === 'full') {
                calculateDropdownPosition(dropdown);
            }

            dropdown.classList.add('show');

            // For regular dropdowns, position after showing
            if (dropdown.dataset.type === 'regular') {
                calculateDropdownPosition(dropdown);
            }
        });

        // Hide dropdown with delay on mouse leave
        navItem.addEventListener('mouseleave', () => {
            const timeoutId = setTimeout(() => {
                dropdown.classList.remove('show');
                dropdownTimeouts.delete(navItem);
            }, 300);

            dropdownTimeouts.set(navItem, timeoutId);
        });

        // Keep dropdown open when hovering over dropdown content
        dropdown.addEventListener('mouseenter', () => {
            // Clear timeout if hovering over dropdown
            if (dropdownTimeouts.has(navItem)) {
                clearTimeout(dropdownTimeouts.get(navItem));
                dropdownTimeouts.delete(navItem);
            }
        });

        // Hide dropdown when leaving dropdown content
        dropdown.addEventListener('mouseleave', () => {
            const timeoutId = setTimeout(() => {
                dropdown.classList.remove('show');
                dropdownTimeouts.delete(navItem);
            }, 300);

            dropdownTimeouts.set(navItem, timeoutId);
        });
    });
}

// Initialize mobile navigation
function initMobileNav() {
    const mobileNav = document.getElementById('mobile-nav');
    if (!mobileNav) return;

    const toggleButtons = mobileNav.querySelectorAll('[data-toggle]');

    toggleButtons.forEach((button) => {
        const toggleKey = button.dataset.toggle;
        const submenu = mobileNav.querySelector(
            `[data-submenu="${toggleKey}"]`
        );
        const chevron = button.querySelector('svg');

        if (!submenu || !chevron) return;

        button.addEventListener('click', () => {
            if (expandedMobileItems.has(toggleKey)) {
                // Collapse
                expandedMobileItems.delete(toggleKey);
                submenu.classList.add('hidden');
                chevron.style.transform = 'rotate(0deg)';
            } else {
                // Expand
                expandedMobileItems.add(toggleKey);
                submenu.classList.remove('hidden');
                chevron.style.transform = 'rotate(180deg)';
            }
        });
    });
}

// Initialize mobile menu toggle
function initMobileMenu() {
    const toggleButton = document.getElementById('mobile-menu-toggle');
    const mobileMenu = document.getElementById('mobile-menu');
    const hamburgerIcon = document.getElementById('hamburger-icon');
    const closeIcon = document.getElementById('close-icon');

    if (!toggleButton || !mobileMenu || !hamburgerIcon || !closeIcon) return;

    toggleButton.addEventListener('click', () => {
        isMobileMenuOpen = !isMobileMenuOpen;

        if (isMobileMenuOpen) {
            mobileMenu.classList.add('show');
            hamburgerIcon.classList.add('hidden');
            closeIcon.classList.remove('hidden');
            document.body.style.overflow = 'hidden';
        } else {
            mobileMenu.classList.remove('show');
            hamburgerIcon.classList.remove('hidden');
            closeIcon.classList.add('hidden');
            document.body.style.overflow = 'unset';

            // Reset expanded items
            expandedMobileItems.clear();
            document.querySelectorAll('[data-submenu]').forEach((submenu) => {
                submenu.classList.add('hidden');
            });
            document
                .querySelectorAll('[data-toggle] svg')
                .forEach((chevron) => {
                    chevron.style.transform = 'rotate(0deg)';
                });
        }
    });

    // Close mobile menu when clicking outside
    document.addEventListener('click', (e) => {
        if (
            isMobileMenuOpen &&
            !document.getElementById('header').contains(e.target)
        ) {
            isMobileMenuOpen = false;
            mobileMenu.classList.remove('show');
            hamburgerIcon.classList.remove('hidden');
            closeIcon.classList.add('hidden');
            document.body.style.overflow = 'unset';

            // Reset expanded items
            expandedMobileItems.clear();
            document.querySelectorAll('[data-submenu]').forEach((submenu) => {
                submenu.classList.add('hidden');
            });
            document
                .querySelectorAll('[data-toggle] svg')
                .forEach((chevron) => {
                    chevron.style.transform = 'rotate(0deg)';
                });
        }
    });

    // Close menu on escape key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isMobileMenuOpen) {
            toggleButton.click();
        }
    });
}

// Search functionality (keep existing search features)
function initSearch() {
    const searchButton = document.getElementById('searchButton');
    const mobileSearchButton = document.getElementById('mobileSearchButton');
    const searchOverlay = document.getElementById('searchOverlay');
    const closeSearch = document.getElementById('closeSearch');
    const searchInput = document.getElementById('searchInput');

    // Desktop search button
    if (searchButton && searchOverlay) {
        searchButton.addEventListener('click', () => {
            searchOverlay.classList.remove('hidden');
            if (searchInput) {
                searchInput.value = '';
                searchInput.focus();
            }
        });
    }

    // Mobile search button
    if (mobileSearchButton && searchOverlay) {
        mobileSearchButton.addEventListener('click', () => {
            searchOverlay.classList.remove('hidden');
            if (searchInput) {
                searchInput.value = '';
                searchInput.focus();
            }

            // Close mobile menu if open
            if (isMobileMenuOpen) {
                document.getElementById('mobile-menu-toggle')?.click();
            }
        });
    }

    // Close search overlay
    if (closeSearch && searchOverlay) {
        closeSearch.addEventListener('click', () => {
            searchOverlay.classList.add('hidden');
        });
    }

    // Close search on overlay click
    if (searchOverlay) {
        searchOverlay.addEventListener('click', (e) => {
            if (e.target === searchOverlay) {
                searchOverlay.classList.add('hidden');
            }
        });
    }

    // Close search on escape key
    document.addEventListener('keydown', (e) => {
        if (
            e.key === 'Escape' &&
            searchOverlay &&
            !searchOverlay.classList.contains('hidden')
        ) {
            searchOverlay.classList.add('hidden');
        }
    });

    // Predictive search functionality - DISABLED FOR PHASE 1
    // Phase 2: Re-enable with proper integration to new two-column layout
    /* COMMENTED OUT - Phase 1: Static layout only
    if (searchInput) {
        let searchTimeout;
        searchInput.addEventListener('input', function () {
            clearTimeout(searchTimeout);
            const query = this.value.trim();

            if (query.length > 2) {
                searchTimeout = setTimeout(() => {
                    performPredictiveSearch(query);
                }, 300);
            } else {
                const resultsContainer =
                    document.getElementById('searchResults');
                if (resultsContainer) {
                    resultsContainer.innerHTML = '';
                }
            }
        });
    }
    */
}

// Predictive search function - DISABLED FOR PHASE 1
/* COMMENTED OUT - Phase 1: Static layout only
function performPredictiveSearch(query) {
    fetch(
        `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`
    )
        .then((response) => response.json())
        .then((data) => {
            displaySearchResults(data.resources.results.products || []);
        })
        .catch((error) => {
            console.error('Search error:', error);
        });
}

// Display search results
function displaySearchResults(products) {
    const resultsContainer = document.getElementById('searchResults');
    if (!resultsContainer) return;

    if (products.length === 0) {
        resultsContainer.innerHTML =
            '<p class="text-gray-500 text-center py-4">No products found</p>';
        return;
    }

    resultsContainer.innerHTML = products
        .map(
            (product) => `
    <a href="${product.url}" class="flex items-center space-x-4 p-4 hover:bg-gray-50 rounded-lg">
      <img src="${product.featured_image}" alt="${product.title}" class="w-12 h-12 object-cover rounded">
      <div class="flex-1">
        <h4 class="font-axiom-medium text-axiom-blue-dark">${product.title}</h4>
        <p class="text-axiom-red-med font-axiom-bold">${product.price}</p>
      </div>
    </a>
  `
        )
        .join('');
}
*/

/* ECOM_DISABLED_START - Cart count update functionality */
/*
// Cart count update functionality
function updateCartCount(count) {
    const cartCount = document.getElementById('cartCount');
    if (cartCount) {
        cartCount.textContent = count;
        if (count > 0) {
            cartCount.classList.remove('hidden');
        } else {
            cartCount.classList.add('hidden');
        }
    }
}
*/
/* ECOM_DISABLED_END */

// Close dropdowns when clicking outside
function closeAllDropdowns() {
    // Clear all timeouts
    dropdownTimeouts.forEach((timeoutId) => {
        clearTimeout(timeoutId);
    });
    dropdownTimeouts.clear();

    // Close all desktop dropdowns
    document
        .querySelectorAll('#desktop-nav .dropdown-menu')
        .forEach((dropdown) => {
            dropdown.classList.remove('show');
        });
}

// Sticky header functionality
function initStickyHeader() {
    const header = document.getElementById('header');
    if (!header) return;

    let headerOffset = 0;
    let isSticky = false;

    // Calculate header's initial position
    function calculateHeaderOffset() {
        const headerRect = header.getBoundingClientRect();
        const scrollTop =
            window.pageYOffset || document.documentElement.scrollTop;
        headerOffset = headerRect.top + scrollTop;
    }

    // Handle scroll events
    function handleScroll() {
        const scrollTop =
            window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop >= headerOffset && !isSticky) {
            // Make header sticky
            header.classList.add('sticky');
            document.body.classList.add('header-sticky');
            isSticky = true;
        } else if (scrollTop < headerOffset && isSticky) {
            // Remove sticky header
            header.classList.remove('sticky');
            document.body.classList.remove('header-sticky');
            isSticky = false;
        }
    }

    // Initialize
    calculateHeaderOffset();

    // Add scroll listener with throttling for performance
    let scrollTimeout;
    window.addEventListener('scroll', () => {
        if (scrollTimeout) {
            cancelAnimationFrame(scrollTimeout);
        }
        scrollTimeout = requestAnimationFrame(handleScroll);
    });

    // Recalculate on resize
    window.addEventListener('resize', () => {
        if (!isSticky) {
            calculateHeaderOffset();
        }
    });
}

// Initialize everything when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    initDesktopNav();
    initMobileNav();
    initMobileMenu();
    initSearch();
    initStickyHeader();

    // Handle window resize
    window.addEventListener('resize', handleResize);

    // Close dropdowns when clicking outside
    document.addEventListener('click', (e) => {
        const isDropdownClick = e.target.closest('.nav-item');
        if (!isDropdownClick) {
            closeAllDropdowns();
        }
    });

    // Close dropdowns on escape key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closeAllDropdowns();
        }
    });

    /* ECOM_DISABLED_START - Cart refresh event listener */
    /*
    // Listen for cart updates
    document.addEventListener('cart:refresh', function (event) {
        if (event.detail && event.detail.cart) {
            updateCartCount(event.detail.cart.item_count);
        }
    });
    */
    /* ECOM_DISABLED_END */
});
